import React, { createContext, useState } from 'react'


export let RegisterSuccessProvider = createContext()


export default function RegisterSuccessful({children}) {
    let [successMessage , setSuccessMessage] = useState('')
  return (
    <RegisterSuccessProvider.Provider value={{successMessage,setSuccessMessage}}>
        {children}
    </RegisterSuccessProvider.Provider>
  )
}
